module.exports = __webpack_public_path__ + "img/mathieu_artu.5f66f762.jpg";